// extracted by mini-css-extract-plugin
export default {"container":"Qo-z","ratingLayout":"Ro-z","ratingLabel":"So-z","nonInteractiveRatingLabel":"To-z"};